import { useTranslations } from "next-intl";

// 错误代码枚举
export enum ERROR_CODE_ENUM {
  /** 不支持的链类型 */
  UnsupportedChainTypesCode = 102001,
  /** 签名解码失败 */
  SignatureDecodingFailedCode = 102002,
  /** 签名长度不正确 */
  SignatureLengthIsIncorrectCode = 102003,
  /** 签名恢复ID无效 */
  InvalidRecoveryIDCode = 102004,
  /** 无法恢复公钥 */
  PublicKeyCannotBeRecoveredCode = 102005,
  /** 签名地址不匹配 */
  SignatureAddressDoesNotMatchCode = 102006,
  /** ip地址错误 */
  IpAddressErrorCode = 102007,
  /** 登录类型错误 */
  InvalidLoginTypeCode = 102008,
  /** 登录超时 */
  LoginTimeoutCode = 102009,
  /** 验证码错误 */
  CAPTCHAErrorCode = 102010,
  /** 账号密码错误 */
  WrongAccountPasswordCode = 102011,
  /** 签名错误 */
  SignatureErrorCode = 102012,
  /** 用户不存在 */
  UserNotFindCode = 102013,
  /** 用户状态异常 */
  UserStatusNotNormalCode = 102014,
  /** 当前设备注册过多，请稍后再试 */
  IpDeviceRegisteredOvermuchCode = 102015,
  /** IP注册超限 */
  RegisterIPLimitExceededCode = 102016,
  /** 用户/IP/设备验证码被冻结 */
  VerifyCodeFrozenCode = 102017,
  /** 用户/IP/设备验证码日限制 */
  VerifyCodeDailyLimitCode = 102018,
  /** 需要人机验证的所有场景 */
  CaptchaRequiredCode = 102019,
  /** 禁止密码登录 */
  PasswordLoginForbiddenCode = 102020,
  /** IP/设备登录被冻结 */
  LoginFrozenCode = 102021,
  /** 用户/IP/设备进入黑名单 */
  BlacklistedCode = 102022,
  /** 通用频率限制 */
  TooManyAttemptsCode = 102023,
  /** 手机号已绑定 */
  PhoneAlreadyBoundCode = 102024,
  /** 邮箱已绑定 */
  EmailAlreadyBoundCode = 102025,
  /** 旧密码错误 */
  OldPasswordErrorCode = 102026,
  /** 绑定失败，可通过个人中心输入邀请码进行绑定，或联系客服。 */
  BindAgentFailureCode = 102028,
  /** 不能输入自己的邀请码 */
  CannotBindUseOwnCode = 102029,
  /** 注册时间已超限 */
  AgentRegisterTimeExceededCode = 102030,
  /** 用户已绑定代理 */
  AgentAlreadyBoundCode = 102031,
  /** 已成功发展下级，不能被绑定 */
  AgentHasReferralsCode = 102032,
  /** 绑定银行卡封禁 */
  BankCardBanCode = 105102,
  /** 提现银行卡封禁 */
  WithdrawBankCardBanCode = 105103,
  /** 当前银行卡已经存在 */
  BankCardAlreadyExists = 105104,
  /** 当前钱包地址已经存在 */
  Web3WalletAlreadyExists = 105105
};

const useAuthError = () => {
  const authT = useTranslations('auth');
  const commonT = useTranslations('common');
  const referralT = useTranslations('referral');
  const personalT = useTranslations('personal');

  const authErrorCodeMap = {
    /** 不支持的链类型 */
    // [ERROR_CODE_ENUM.UnsupportedChainTypesCode]: authT('errors.unsupportedChain'),
    /** 签名解码失败 */
    // [ERROR_CODE_ENUM.SignatureDecodingFailedCode]: authT('errors.signatureDecodingFailed'),
    /** 签名长度不正确 */
    // [ERROR_CODE_ENUM.SignatureLengthIsIncorrectCode]: authT('errors.signatureLengthIncorrect'),
    /** 签名恢复ID无效 */
    // [ERROR_CODE_ENUM.InvalidRecoveryIDCode]: authT('errors.invalidRecoveryId'),
    /** 无法恢复公钥 */
    // [ERROR_CODE_ENUM.PublicKeyCannotBeRecoveredCode]: authT('errors.publicKeyRecoveryFailed'),
    /** 签名地址不匹配 */
    // [ERROR_CODE_ENUM.SignatureAddressDoesNotMatchCode]: authT('errors.signatureAddressMismatch'),
    /** ip地址错误 */
    // [ERROR_CODE_ENUM.IpAddressErrorCode]: authT('tips.areaMismatch'),
    /** 登录类型错误 */
    // [ERROR_CODE_ENUM.InvalidLoginTypeCode]: authT('errors.loginTypeError'),
    /** 登录超时 */
    [ERROR_CODE_ENUM.LoginTimeoutCode]: commonT('errors.requestTimeout'),
    /** 验证码错误 */
    [ERROR_CODE_ENUM.CAPTCHAErrorCode]: authT('errors.invalidCode'),
    /** 账号密码错误 */
    [ERROR_CODE_ENUM.WrongAccountPasswordCode]: authT('errors.invalidPassword'),
    /** 签名错误 */
    // [ERROR_CODE_ENUM.SignatureErrorCode]: authT('errors.signatureError'),
    /** 用户不存在 */
    // [ERROR_CODE_ENUM.UserNotFindCode]: authT('errors.userNotExist'),
    /** 用户状态异常 */
    [ERROR_CODE_ENUM.UserStatusNotNormalCode]: authT('errors.accountUnavailable'),
    /** 当前设备注册过多，请稍后再试 */
    // [ERROR_CODE_ENUM.IpDeviceRegisteredOvermuchCode]: authT('errors.currentDeviceRegisterTooMany'),
    /** IP注册超限 */
    // [ERROR_CODE_ENUM.RegisterIPLimitExceededCode]: authT('errors.ipRegisterLimit'),
    /** 用户/IP/设备验证码被冻结 */
    // [ERROR_CODE_ENUM.VerifyCodeFrozenCode]: authT('errors.userIpDeviceVerificationCodeFrozen'),
    /** 用户/IP/设备验证码日限制 */
    [ERROR_CODE_ENUM.VerifyCodeDailyLimitCode]: commonT('102018'),
    /** 需要人机验证的所有场景 */
    [ERROR_CODE_ENUM.CaptchaRequiredCode]: authT('cloudflare.text1'),
    /** 禁止密码登录 */
    [ERROR_CODE_ENUM.PasswordLoginForbiddenCode]: authT('errors.contactSupport'),
    /** IP/设备登录被冻结 */
    [ERROR_CODE_ENUM.LoginFrozenCode]: authT('errors.contactSupport'),
    /** 用户/IP/设备进入黑名单 */
    [ERROR_CODE_ENUM.BlacklistedCode]: authT('errors.contactSupport'),
    /** 通用频率限制 */
    [ERROR_CODE_ENUM.TooManyAttemptsCode]: authT('verification.tooFrequent'),
    /** 手机号已绑定 */
    [ERROR_CODE_ENUM.PhoneAlreadyBoundCode]: authT('validation.phoneAlreadyBound'),
    /** 邮箱已绑定 */
    [ERROR_CODE_ENUM.EmailAlreadyBoundCode]: authT('validation.emailAlreadyBound'),
    /** 旧密码错误 */
    [ERROR_CODE_ENUM.OldPasswordErrorCode]: authT('errors.invalidPassword'),
    /** 绑定失败，可通过个人中心输入邀请码进行绑定，或联系客服。 */
    [ERROR_CODE_ENUM.BindAgentFailureCode]: referralT('bindFailureMessage'),
    /** 不能输入自己的邀请码 */
    [ERROR_CODE_ENUM.CannotBindUseOwnCode]: referralT('cannotUseOwnCode'),
    /** 注册时间已超限 */
    [ERROR_CODE_ENUM.AgentRegisterTimeExceededCode]: referralT('tooLongCanNotBind'),
    /** 用户已绑定代理 */
    [ERROR_CODE_ENUM.AgentAlreadyBoundCode]: referralT('alreadyBound', { 0: '', 1: '' }),
    /** 已成功发展下级，不能被绑定 */
    [ERROR_CODE_ENUM.AgentHasReferralsCode]: referralT('hasReferralsCannotBind'),
    /** 绑定银行卡封禁 */
    [ERROR_CODE_ENUM.BankCardBanCode]: commonT('105102'),
    /** 提现银行卡封禁 */
    [ERROR_CODE_ENUM.WithdrawBankCardBanCode]: commonT('105103'),
    /** 当前银行卡已经存在 */
    [ERROR_CODE_ENUM.BankCardAlreadyExists]: personalT('needChangeCard'),
    /** 当前钱包地址已经存在 */
    [ERROR_CODE_ENUM.Web3WalletAlreadyExists]: personalT('addressAlreadyExists'),
  };
  const getAuthErrorTextByCode = (code: number) => {
    return authErrorCodeMap[code];
  };
  return {
    getAuthErrorTextByCode,
    authErrorCodeMap
  };
};

export {
  useAuthError,
};